<template>
    <v-container>
        <v-layout>
            <v-flex>
                <v-tooltip top>
                    <v-btn
                            class="mr-2 mb-2"
                            @click="newCovidPatientAlarm"
                            color="customPurple"
                            dark
                            fixed
                            bottom
                            right
                            fab
                            slot="activator"
                    >
                        <v-icon>add</v-icon>
                    </v-btn>
                    <span>Registro Alarma</span>
                </v-tooltip>
                <div>
                    <v-layout>
                        <v-flex xs12 sm6 offset-sm6>
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-dialog
                    v-model="dialog"
                    fullscreen hide-overlay transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false" @click="cleanData">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Crear nueva alarma</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <p  class="font-weight-bold">SINTOMATOLOGÍA</p>
                            <p  class="font-weight-bold">¿Presenta el día de hoy, alguno de los siguientes síntomas?</p>

                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <p  class="font-weight-bold">1. Temperatura mayor a 37.5 grados centígrados ( fiebre ) *</p>
                                    <v-select
                                            v-model="covidPatientAlarm.response1"
                                            :items="this.itemsElements"
                                            item-text="name"
                                            item-value="id"
                                            return-object
                                            required
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <p  class="font-weight-bold">2. Tos</p>
                                    <v-select
                                            v-model="covidPatientAlarm.response2"
                                            :items="this.itemsElements"
                                            item-text="name"
                                            item-value="id"
                                            return-object
                                            required
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <p  class="font-weight-bold">3. Dificultad al respirar ( le falta el aire )</p>
                                    <v-select
                                            v-model="covidPatientAlarm.response3"
                                            :items="this.itemsElements"
                                            item-text="name"
                                            item-value="id"
                                            return-object
                                            required
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <p  class="font-weight-bold">4. Pérdida del gusto</p>
                                    <v-select
                                            v-model="covidPatientAlarm.response4"
                                            :items="this.itemsElements"
                                            item-text="name"
                                            item-value="id"
                                            return-object
                                            required
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <p  class="font-weight-bold">5. Pérdida del olfato</p>
                                    <v-select
                                            v-model="covidPatientAlarm.response5"
                                            :items="this.itemsElements"
                                            item-text="name"
                                            item-value="id"
                                            return-object
                                            required
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <p  class="font-weight-bold">EXPOSICIÓN</p>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <p  class="font-weight-bold">6. ¿En los últimos 7 días ha estado en contacto con alguna persona que tenia tos o fiebre? </p>
                                    <v-select
                                            v-model="covidPatientAlarm.response6"
                                            :items="this.itemsElements"
                                            item-text="name"
                                            item-value="id"
                                            return-object
                                            required
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <p  class="font-weight-bold">7. ¿En la casa o su trabajo, ha estado en contacto o existe sospecha de alguna persona con coronavirus? </p>
                                    <v-select
                                            v-model="covidPatientAlarm.response7"
                                            :items="this.itemsElements"
                                            item-text="name"
                                            item-value="id"
                                            return-object
                                            required
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm6 offset-sm4>
                                    <div>
                                        <v-btn :disabled="!valid"
                                               @click="saveData" large color="primary">Guardar
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
        </v-layout>
        <h3 class="primary--text">Lista de Alarmas por paciente</h3>
        <v-data-table
                :headers="headers"
                :items="covidPatientAlarmList"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="search"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.covidPatient.lastName }} {{ props.item.covidPatient.name }}</td>
                <td class="text-xs-left">{{ props.item.covidPatient.identification }}</td>
                <td class="text-xs-left">{{ getFormattedDate(props.item.date) }}</td>
                <td class="text-xs-left">{{ props.item.response1 }}</td>
                <td class="text-xs-left">{{ props.item.response2 }}</td>
                <td class="text-xs-left">{{ props.item.response3 }}</td>
                <td class="text-xs-left">{{ props.item.response4 }}</td>
                <td class="text-xs-left">{{ props.item.response5 }}</td>
                <td class="text-xs-left">{{ props.item.response8 }}</td>
                <td class="text-xs-left">{{ props.item.response9 }}</td>
                <td class="text-xs-left">{{ props.item.response6 }}</td>
                <td class="text-xs-left">{{ props.item.response7 }}</td>
                <td>
<!--                    <v-tooltip top>-->
<!--                        <v-btn-->
<!--                                fab dark-->
<!--                                small @click="editItem(props.item)"-->
<!--                                slot="activator"-->
<!--                                color="primary">-->
<!--                            <v-icon dark>edit</v-icon>-->
<!--                        </v-btn>-->
<!--                        <span>Editar</span>-->
<!--                    </v-tooltip>-->
                    <v-tooltip top>
                        <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                            <v-icon dark>delete</v-icon>
                        </v-btn>
                        <span>Eliminar</span>
                    </v-tooltip>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
    </v-container>
</template>
<script>
    import CovidPatient from "../../model/CovidPatient";
    import CovidPatientAlarm from "../../model/CovidPatientAlarm";

    export default {
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                statusItems: ['ACTIVO',
                    'INACTIVO'],
                itemsElements: ['SI','NO'],
                headers: [
                    {text: 'Paciente', value: 'covidPatient.lastName'},
                    {text: 'Identificación', value: 'covidPatient.idnetification'},
                    {text: 'Fecha alarma', value: 'identification'},
                    {text: 'Fiebre', value: 'response1'},
                    {text: 'Tos', value: 'response2'},
                    {text: 'Disnea', value: 'response3'},
                    {text: 'Ageusia', value: 'response4'},
                    {text: 'Anosmia', value: 'response5'},
                    {text: 'Rinorrea', value: 'response8'},
                    {text: 'Dearrea', value: 'response9'},
                    {text: 'Contacto tos fiebre', value: 'response6'},
                    {text: 'Contacto COVID', value: 'response7'},
                    {text: 'Opciones', value: 'options'}

                ],
                editedIndex: -1,
                covidPatientAlarm: new CovidPatientAlarm(),
                covidPatientAlarmList: []
            };
        },
        methods: {
            cleanData() {
                this.$refs.form.reset();
                this.covidPatientAlarm = new CovidPatientAlarm();
                this.valid = false;
                this.dialog = false;
            },
            newCovidPatientAlarm() {
                this.editedIndex = -1;
                this.valid = false;
                this.dialog = true;
                this.$refs.form.reset();
                this.covidPatientAlarm = new CovidPatientAlarm();
            },
            saveData() {
                if (this.$refs.form.validate()) {
                    if (this.editedIndex > -1) {
                        this.$store.dispatch('updateCovidPatientAlarm', this.covidPatientAlarm).then(
                            response => {
                                this.loadData();
                                this.cleanData();
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                                this.$store.state.dialogErrorMessage = 'No se pudo modificar la alarma verifique la información'
                            }
                        );
                    } else {
                        this.covidPatientAlarm.covidPatient = this.$store.state.covidPatient
                        this.$store.dispatch('addCovidPatientAlarm', this.covidPatientAlarm).then(
                            response => {
                                this.loadData();
                                this.cleanData();
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                                this.$store.state.dialogErrorMessage = 'No se pudo crear la alarma verifique la información'
                            }
                        );
                    }
                    this.dialog = false;
                }
            },
            editItem(item) {
                this.editedIndex = this.covidPatientAlarmList.indexOf(item);
                this.covidPatientAlarm = Object.assign({}, item);

                this.dialog = true;
            },
            deleteItem(item) {
                this.editedIndex = this.covidPatientAlarmList.indexOf(item);
                this.covidPatientAlarm = Object.assign({}, item);
                confirm('Está seguro de que quiere eliminar el registro?') &&
                this.$store.dispatch('deleteCovidPatientAlarm', this.covidPatientAlarm.id).then(response => {
                    this.loadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            loadData(){
                this.$store.dispatch('getCovidPatientAlarmByPatient',this.$store.state.covidPatient.id).then(
                    response => {
                        this.covidPatientAlarmList = response.data
                        this.cleanData();
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
            },
            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (true) {
                    // Para Safari
                    if (!(dateReg instanceof Date)) {
                        var b = dateReg.toString().split(/\D/);
                        date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                    } else {
                        date = new Date(dateReg);
                    }
                }  else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            },
        },
        computed: {},
        created() {
            this.loadData()
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/covid/CovidPatientAlarm.vue